import { initializeChatPage } from './chat.js';
import { initializeFaq } from './faq.js';
import { initializePersonaPage } from './persona.js';
import { initHistory } from './history.js'; // Import history module
import { initializeGalaxy } from './galaxy.js';

// ===== GENERAL INITIALIZERS =====

function initializeTooltips() {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });
}

function handleCookieConsent() {
    const cookieBanner = document.getElementById('cookie-consent-banner');
    const acceptCookies = document.getElementById('accept-cookies');
    if (!cookieBanner || !acceptCookies) return;
    if (localStorage.getItem('cookie_consent') === 'true') {
        cookieBanner.style.display = 'none';
    }
    acceptCookies.addEventListener('click', () => {
        localStorage.setItem('cookie_consent', 'true');
        cookieBanner.style.display = 'none';
    });
}



// ===== DOMContentLoaded =====

document.addEventListener('DOMContentLoaded', () => {
    initializeTooltips();
    handleCookieConsent();

    if (document.querySelector('.faq-question')) {
        initializeFaq();
    }
    if (document.getElementById('start-button')) {
        initializePersonaPage();
    }
    if (document.getElementById('frageForm')) {
        initializeChatPage();
        initHistory(); // Initialize history module
    }
    if (document.getElementById('galaxy-network')) {
        initializeGalaxy();
    }
});
